export default "__VITE_ASSET__6c30d072__"